export default {
    "alertLog_driver": "Driver",
    "alertLog_landmark": "Landmark",
    "alertLog_alertName": "Alert",
    "alertLog_unitTime": "Unit Time",
    "alertLog_address": "Address",
    "alertLog_vehicleName": "Vehicle Name",
    "alertLog_currentTime": "Current Time"
}